module.exports = __webpack_public_path__ + "static/media/0_2020_03_26.08954bf6.jpg";